import React from 'react';

import { Box, Grid } from '@mui/material';
import { FieldValues } from 'react-hook-form';
import { makeStyles } from 'tss-react/mui';

import { OhsFormSettings } from 'global-components/form/services/OhsFormModels';
import { useAppSelector } from 'app/hooks';
import OhsSelectField from 'global-components/form/fields/OhsSelectField';
import OhsMultipleSelectField from 'global-components/form/fields/OhsMultipleSelectField';
import { myCommMappedStatus, MyCommStatus } from 'admin2/my-hub/models/OhsMyHubModel';
import OhsDateRangePickerNew from 'global-components/form/fields/OhsDateRangePickerNew';
import { getTodayDateString } from 'global-services/utils/OhsDateServices';

import { getGlobalFilter } from '../OhsTopFilterSlice';
import { OhsFilterList } from '../OhsFilterModels';

const useStyles = makeStyles()(() => ({
  root: {
    flexGrow: 1,
  },
  fieldWrap: {
    margin: '10px 0 10px 0',
  },
  filterContent: {
    width: '100%',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));
interface Props {
  ohsFormSettings: OhsFormSettings<FieldValues>;
}

const statuses: MyCommStatus[] = ['SENT', 'VIEWED', 'CLOSED'];

function OhsMyCommunicationFilters(props: Props) {
  const { classes } = useStyles();
  const filter = useAppSelector(getGlobalFilter) as OhsFilterList;
  const statusOptions = statuses.map((item) => ({ name: myCommMappedStatus[item], value: item }));

  return (
    <Box className={classes.filterContent}>
      <Grid item md={12} xs={12} className={classes.fieldWrap}>
        <OhsSelectField
          title="Sort By"
          id="myCommunicationModule.sort"
          required
          options={filter.myCommunicationModule.tableSortKeyLists?.sortColAscDescOptions}
          ohsFormSettings={props.ohsFormSettings}
        />
      </Grid>
      <Grid item md={12} xs={12} className={classes.fieldWrap}>
        <OhsMultipleSelectField
          title="Status"
          id="myCommunicationModule.status"
          required={false}
          options={statusOptions}
          ohsFormSettings={props.ohsFormSettings}
        />
      </Grid>
      <Grid item md={12} xs={12} className={classes.fieldWrap}>
        <OhsDateRangePickerNew
          id="myCommunicationModule.dateExchange"
          label="Created Date"
          ohsFormSettings={props.ohsFormSettings}
          maxDate={{ name: 'Today', date: getTodayDateString() }}
        />
      </Grid>
    </Box>
  );
}

export default OhsMyCommunicationFilters;
